import React, { useState } from 'react';
import '../assets/main.css';
import apiService from '../helper/apiService';
import { APIS } from '../apis';
import { getUserName } from '../helper/access';

function Calendar() {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);
  const [generatedLink, setGeneratedLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const changeMonth = (offset) => {
    let newMonth = currentMonth + offset;
    let newYear = currentYear;

    if (newMonth < 0) {
      newMonth = 11;
      newYear--;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear++;
    }

    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
    clearSelection();
  };

  const clearSelection = () => {
    setSelectedDate(null);
    setGeneratedLink(null);
    setLoading(false);
  };

  const daysInMonth = getDaysInMonth(currentYear, currentMonth);
  const firstDay = getFirstDayOfMonth(currentYear, currentMonth);

  const todayDate = today.getDate();
  const isCurrentMonth = currentMonth === today.getMonth() && currentYear === today.getFullYear();

  const calendarCells = [];

  for (let i = 0; i < firstDay; i++) {
    calendarCells.push(<div className="calendar-cell empty" key={`empty-${i}`} />);
  }

  for (let d = 1; d <= daysInMonth; d++) {
    const isToday = isCurrentMonth && d === todayDate;
    const isSelected =
      selectedDate &&
      selectedDate.getDate() === d &&
      selectedDate.getMonth() === currentMonth &&
      selectedDate.getFullYear() === currentYear;

    calendarCells.push(
      <div
        className={`calendar-cell day ${isToday ? 'today' : ''} ${isSelected ? 'selected' : ''}`}
        key={d}
        onClick={() => {
          setSelectedDate(new Date(currentYear, currentMonth, d));
          setGeneratedLink(null); // reset link on new date select
        }}
        style={{ cursor: 'pointer' }}
        title={`Select ${d} ${monthNames[currentMonth]} ${currentYear}`}
      >
        {d}
      </div>
    );
  }

  const createLink = async () => {
    if (!selectedDate) return;
    setLoading(true);
    setGeneratedLink(null);
    try {
      let payload = {
        roomId: "doctor_rm",
        userName: getUserName(),
        meetingType: "instant",
        participants: ["ram","lakshmi","chinna","bablu","praveen"]
      }
      const response = await apiService.post(`${APIS.CREATE_ROOM}`, payload);
      if (response?.data?.room_unique_id) {
        setGeneratedLink(response?.data?.room_unique_id);
      } else {
        setGeneratedLink(null);
      }
    } catch (err) {
      alert('Error creating link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 1500); // Hide message after 1.5s
    }).catch(() => {
      alert('Failed to copy link.');
    });
  };


  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={() => changeMonth(-1)}>&lt;</button>
        <span>{monthNames[currentMonth]} {currentYear}</span>
        <button onClick={() => changeMonth(1)}>&gt;</button>
      </div>

      <div className="calendar-grid header">
        {daysOfWeek.map(day => (
          <div className="calendar-cell header-cell" key={day}>{day}</div>
        ))}
      </div>

      <div className="calendar-grid">
        {calendarCells}
      </div>

      {selectedDate && (
        <div className="selected-date-display">
          <h4>Schedule Meeting</h4>
          <div className="selected-date-grid">
            <div><strong>Date:</strong> {selectedDate.getDate()}</div>
            <div><strong>Month:</strong> {monthNames[selectedDate.getMonth()]}</div>
            <div><strong>Year:</strong> {selectedDate.getFullYear()}</div>
            <div><strong>Day:</strong> {selectedDate.toLocaleDateString('en-US', { weekday: 'long' })}</div>
            <p><strong>Patient name</strong></p>
            <p><input type="text"></input></p>
            <p><strong>Start Time</strong></p>
            <p><input type="text"></input></p>
            <p><strong>End Time</strong></p>
            <p><input type="text"></input></p>
            {generatedLink && (
              <div className="generated-link" style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
                <strong>Generated Link: </strong>
                <div className="link-copy-container">
                  <a href={generatedLink} target="_blank" rel="noopener noreferrer">{generatedLink}</a>
                  <button className="copy-button" onClick={() => handleCopyLink(generatedLink)}>Copy</button>
                </div>
                {copySuccess && <div className="copy-success">Copied!</div>}
              </div>
            )}

          </div>

          <div style={{ marginTop: '1rem' }}>
            <button onClick={createLink} disabled={loading} style={{ marginRight: '10px' }}>
              {loading ? 'Schedule a call...' : 'Schedule a call'}
            </button>
            <button onClick={clearSelection}>Clear</button>
          </div>
        </div>
      )}


    </div>
  );
}

export default Calendar;
